import { useAuthStore } from '@/stores/authStore';
import { HiOutlineUser, HiOutlineOfficeBuilding, HiOutlineCog } from 'react-icons/hi';

export default function SettingsPage() {
  const user = useAuthStore((state) => state.user);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">設定</h1>
        <p className="text-gray-600 mt-1">システムの設定を管理します</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* ユーザー情報 */}
        <div className="card">
          <div className="card-header">
            <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
              <HiOutlineUser className="w-5 h-5" />
              ユーザー情報
            </h2>
          </div>
          <div className="card-body space-y-4">
            <div>
              <label className="label">名前</label>
              <p className="text-gray-900">{user?.name || '-'}</p>
            </div>
            <div>
              <label className="label">メールアドレス</label>
              <p className="text-gray-900">{user?.email || '-'}</p>
            </div>
            <div>
              <label className="label">権限</label>
              <p className="text-gray-900">{user?.role || '-'}</p>
            </div>
          </div>
        </div>

        {/* 事業所情報 */}
        <div className="card">
          <div className="card-header">
            <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
              <HiOutlineOfficeBuilding className="w-5 h-5" />
              事業所情報
            </h2>
          </div>
          <div className="card-body">
            <p className="text-gray-500">事業所情報の設定は管理者のみ変更可能です</p>
          </div>
        </div>

        {/* システム設定 */}
        <div className="card md:col-span-2">
          <div className="card-header">
            <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
              <HiOutlineCog className="w-5 h-5" />
              システム設定
            </h2>
          </div>
          <div className="card-body">
            <p className="text-gray-500">システム設定は今後のバージョンで追加予定です</p>
          </div>
        </div>
      </div>
    </div>
  );
}


